import { Box, HStack, Text, Table, Badge, Progress } from '@chakra-ui/react';
import type { CampaignTurfRowDto } from '../../../types/campaign'

interface Props {
  turfs: CampaignTurfRowDto[] | undefined
}

export function ActiveTurfsTable({ turfs }: Props) {
  if (!turfs || turfs.length === 0) {
    return (
      <Box p={8} bg="gray.50" borderRadius="md" textAlign="center">
        <Text color="gray.500">No turfs assigned yet.</Text>
      </Box>
    )
  }

  return (
    <Table.Root size="sm">
      <Table.Header bg="gray.50">
        <Table.Row>
          <Table.ColumnHeader w="50px">#</Table.ColumnHeader>
          <Table.ColumnHeader>Label</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='end'>Members</Table.ColumnHeader>
          <Table.ColumnHeader>Progress</Table.ColumnHeader>
          <Table.ColumnHeader>Assigned</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {turfs.map((turf, idx) => {
          const pct = turf.memberCount > 0
            ? Math.round((turf.visitedCount / turf.memberCount) * 100)
            : 0

          return (
            <Table.Row key={turf.turfId} _hover={{ bg: 'gray.50' }}>
              <Table.Cell>
                <Text fontSize="sm" color="gray.500">{turf.turfIndex || idx + 1}</Text>
              </Table.Cell>
              <Table.Cell>
                <HStack gap={2}>
                  <Text fontSize="sm" fontWeight="medium">{turf.turfLabel}</Text>
                  {turf.generation > 1 && (
                    <Badge colorPalette="purple" fontSize="2xs">
                      Gen {turf.generation}
                    </Badge>
                  )}
                </HStack>
              </Table.Cell>
              <Table.Cell textAlign='end'>
                <Text fontSize="sm">{turf.memberCount}</Text>
              </Table.Cell>
              <Table.Cell>
                <HStack gap={2}>
                  <Progress.Root
                    value={pct}
                    size="xs"
                    colorPalette={pct === 100 ? 'green' : 'blue'}
                    borderRadius="full"
                    w="60px">
                    <Progress.Track>
                      <Progress.Range />
                    </Progress.Track>
                  </Progress.Root>
                  <Text fontSize="xs" color="gray.500">
                    {turf.visitedCount}/{turf.memberCount}
                  </Text>
                </HStack>
              </Table.Cell>
              <Table.Cell>
                <Text fontSize="sm">{turf.assignedToName ?? '—'}</Text>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table.Root>
  );
}
